import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { FiArrowRight, FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const BlogSection = () => {
  const slides = [
    {
      image: "https://cdn.prod.website-files.com/64d13f6ce094cf9b34b8f52f/687d5632d2fea60463d6547a_2025-Tax-Law-Changes-Income-Brackets-Deductions-Retirement-Savings-1.jpg",
      alt: "2025 Tax Law Changes"
    },
    {
      image: "https://cdn.prod.website-files.com/64d13f6ce094cf9b34b8f52f/64d54d1bf1f5d52420385a6d_Taxes%20To%20Go%20cutout.png",
      alt: "Taxes To Go App"
    },
    {
      image: "https://cdn.prod.website-files.com/64d13f6ce094cf9b34b8f52f/688e81aacf4ebc19a68175a4_create%20a%20button%20for%20.png",
      alt: "Tax Resources"
    },
    {
      image: "https://cdn.prod.website-files.com/64d13f6ce094cf9b34b8f52f/64e25566e073f39027d0319c_resources.jpg",
      alt: "Financial Resources"
    }
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef(null);

  React.useEffect(() => {
    const interval = setInterval(() => {
      goToNextSlide();
    }, 5000);
    
    return () => clearInterval(interval);
  }, [currentSlide]);

  const goToNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const goToPrevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section className="py-20 bg-gray-100">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="bg-white p-8 rounded-xl shadow-lg"
          >
            <h2 className="text-3xl font-bold mb-4">Featured Blog Posts</h2>
            <p className="text-gray-700 mb-8">
              Stay up to date on tax laws, recent tax season changes/updates, client resources available, & other pertinent information.
            </p>
            <a 
              href="https://snowstaxfinancial.blogspot.com/"
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors"
            >
              <span>Check it out!</span>
              <FiArrowRight className="ml-2" />
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative overflow-hidden rounded-xl shadow-lg"
            ref={sliderRef}
          >
            {/* Image slider with smaller images */}
            <div className="aspect-[4/3] w-full max-w-md mx-auto">
              <div className="absolute inset-0 flex transition-transform duration-500 ease-in-out" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
                {slides.map((slide, index) => (
                  <div key={index} className="w-full flex-shrink-0 px-2">
                    <img 
                      src={slide.image} 
                      alt={slide.alt} 
                      className="w-full h-full object-contain rounded-lg"
                    />
                  </div>
                ))}
              </div>
            </div>
            
            {/* Navigation arrows */}
            <button 
              onClick={goToPrevSlide}
              className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white w-10 h-10 rounded-full flex items-center justify-center shadow-md z-10"
              aria-label="Previous slide"
            >
              <FiChevronLeft className="text-blue-600" size={24} />
            </button>
            
            <button 
              onClick={goToNextSlide}
              className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white w-10 h-10 rounded-full flex items-center justify-center shadow-md z-10"
              aria-label="Next slide"
            >
              <FiChevronRight className="text-blue-600" size={24} />
            </button>
            
            {/* Dots */}
            <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-2">
              {slides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-3 h-3 rounded-full ${currentSlide === index ? 'bg-blue-600' : 'bg-white/70'}`}
                  aria-label={`Go to slide ${index + 1}`}
                ></button>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;